import { Component } from '@angular/core';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { ExternalLink } from '@shared/directives/external-link';
import { HyphenatePipe } from '@shared/pipes/hyphenate-pipe';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.html',
  styleUrl: './footer.scss',
  imports: [RouterLink, ExternalLink, TranslatePipe, HyphenatePipe]
})
export class Footer {
  protected currentYear: number = new Date().getFullYear();
}
